import styled from "styled-components";
import Button from "@ingka/button";
import { Link } from "react-router-dom";

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;

  ${({ theme }) => `${theme.breakpoints.xxl} {
      display: grid;
      grid-template-rows: none;
      grid-template-columns: 50% 50%;
    }
  `}
`;

export const SlideShowWrapper = styled.section`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  width: auto;

  ${({ theme }) => `${theme.breakpoints.md} {
    width: 400px;
  }
`}
`;

export const Label = styled.p`
  font-size: 0.75rem;
  margin-bottom: var(--space-50);
  order: 1;
`;

export const Content = styled.div`
  padding: var(--space-50) var(--space-100) var(--space-100);
  background-color: var(--colour-bg-alternative);
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  order: 2;
  > *:not(${Label}) {
    order: 2;
  }
`;

export const Children = styled.div`
  margin-bottom: var(--space-100);
`;

export const Title = styled.h2`
  margin-bottom: var(--space-150);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  max-height: 4.25rem;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-word;
`;

export const ImageWrapper = styled.div`
  overflow: hidden;
  position: relative;
  order: 1;
`;

export const ButtonWrapper = styled.div`
  margin-top: auto;
`;

export const ArrowButton = styled(Button)`
  background-color: var(--colour-neutral-white);
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;
